
import CommandsMenu from './commands-menu'
import Prompts from './prompts.vue'

export default {
  components: {CommandsMenu, Prompts},
  props: {
    uploadsEnabled: {type: Boolean, default: true},
    canUpload: {type: Boolean, default: false},
  },
  emits: ['skill', 'source', 'upload', 'prompt'],
}
